exports.f = require('../internals/well-known-symbol');



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/internals/wrapped-well-known-symbol.js
// module id = 2oKg
// module chunks = 18 19